import { render, staticRenderFns } from "./DrugAllocationInputs.vue?vue&type=template&id=f95645ce&scoped=true&"
import script from "./DrugAllocationInputs.vue?vue&type=script&lang=js&"
export * from "./DrugAllocationInputs.vue?vue&type=script&lang=js&"
import style0 from "./DrugAllocationInputs.vue?vue&type=style&index=0&id=f95645ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95645ce",
  null
  
)

export default component.exports